<template>
  <div>
    <v-container>
      <!-- <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" class="py-0 my-0">
          <v-text-field
          label="Subject"
          class="py-0 my-0"
          v-model="model.subject"
          ></v-text-field>
        </v-col>
      </v-row> -->
      <employee-selection :show-dense="false" :show-select="true" v-model="employees" :pay-loc="payLoc" :key="componentKey"></employee-selection>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-btn
            color="success"
            :loading="isSaving"
            @click.stop="save"
            >Save</v-btn
          >
        </v-col>
      </v-row>
      <br/>
      <v-divider></v-divider>
      <v-data-table :items="items" :headers="headers">
        <template v-slot:item.actions="{ item }">
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
import EmployeeSelection from "@/views/maintenance/employee-masterfile/personal-info/NewSelection";
const API_ENDPOINT = "/api/onboardingEmailNotif"
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    employees: [],
    payLoc: [],
    componentKey: 0,
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Name",
        value: "fullName",
        sortable: false
      }
    ],
    isSaving: false,
    model: {
      transType: "NFLPS"
    }
  }),
  components: {
    EmployeeSelection
  },
  methods: {
    save() {
      this.isSaving = true;
      this.model.recipient = this.employees;
      this.$axios.post(`${API_ENDPOINT}/recipient`, this.model)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false
        })
    },
    getRecipients() {
      this.$axios.get(`${API_ENDPOINT}/recipient/${this.model.transType}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    deleteItem(item) {
      this.$axios.delete(`${API_ENDPOINT}/${item.transType}/${item.recipient}`)
        .then(({ data }) => {
           this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    reset() {
      this.componentKey += 1;
      this.getRecipients();
    }
  },
  created() {
    this.getRecipients();
  }
}
</script>